import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getWeb2WaveUserIdAction } from 'root-redux/actions/user'
import { selectAppName } from 'root-redux/selects/common'
import { selectAuthToken, selectUserCohort } from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { AppName } from 'root-constants'

const WEB2WAVE_COHORT_NAME = 'web2wave'

const W2W_MANAGE_SUBSCRIPTION_URLS: Record<string, string> = {
  [AppName.FITME]: 'https://wave.fitme.expert/manage-subscription',
}

/**
 * Web2wave users manage their subscriptions outside of the web account,
 * so they are redirected to the web2wave flow right after the login.
 * The check is made only for the apps listed above and only for the
 * web2wave cohort, all the other users are not affected in any way.
 */
export const useWeb2WaveRedirect = (): boolean => {
  const dispatch: TAppDispatch = useDispatch()

  const appName = useSelector(selectAppName)
  const authToken = useSelector(selectAuthToken)
  const cohortName = useSelector(selectUserCohort)

  const [isRedirectInProgress, setIsRedirectInProgress] = useState(false)
  const isRequestedRef = useRef(false)

  const manageSubscriptionUrl = W2W_MANAGE_SUBSCRIPTION_URLS[appName]

  useEffect(() => {
    if (
      !manageSubscriptionUrl ||
      !authToken ||
      cohortName !== WEB2WAVE_COHORT_NAME ||
      isRequestedRef.current
    ) {
      return
    }

    isRequestedRef.current = true
    setIsRedirectInProgress(true)

    dispatch(getWeb2WaveUserIdAction()).then((web2waveUserId: string) => {
      if (!web2waveUserId) {
        setIsRedirectInProgress(false)
        return
      }

      window.location.replace(
        `${manageSubscriptionUrl}?user_id=${encodeURIComponent(
          web2waveUserId,
        )}#manage_subscription`,
      )
    })
  }, [authToken, cohortName, dispatch, manageSubscriptionUrl])

  return isRedirectInProgress
}
